import React from "react";
import { useTranslation } from "react-i18next";


interface ITaxesServiceComponentProps {
    fee: string;
}

export function TaxesServiceComponent({ fee }: ITaxesServiceComponentProps) {
    const { t } = useTranslation();

    function render() {
        if (fee === 'DELIVERY') {
            return t('taxes.dialog.delivery')
        }
        if (fee === "SERVICE") {
            return t('taxes.dialog.service');
        }
        return null;
    }
    return <div style={{ lineHeight: "40px" }}>
        {render()}
    </div>
}